import Vue from 'vue'
import Vuex from 'vuex'
import users from './modules/users'
import auth from './modules/auth'
import chat from './modules/chat'
import axios from 'axios'
import { Notification } from 'element-ui'
import config from '../config.js'
import * as MutationTypes from './mutation-types'
import dictionaryForMenu from './dictionaryForMenu'

Vue.use(Vuex)
function translate (term) {
  return dictionaryForMenu[term] ? dictionaryForMenu[term] : ''
}
function intComments (workingApplication) {
  let internalComments = []
  if (workingApplication.applicationHistory) {
    let historySteps = workingApplication.applicationHistory.slice(0).reverse()
    for (let step = 0; step < historySteps.length; step++) {
      if (historySteps[step].judgment !== null) {
        if (historySteps[step].judgment.internalComment !== undefined) {
          if (historySteps[step].judgment.internalComment !== null && historySteps[step].judgment.internalComment !== '') {
            internalComments.push({status: historySteps[step].applicationStatus,
              internalComment: historySteps[step].judgment.internalComment,
              dateCompleted: historySteps[step].dateCompleted,
              name: historySteps[step].user.name + ' ' + historySteps[step].user.surname,
              role: historySteps[step].role})
          }
        } else {
          if (historySteps[step].applicationStatus.includes('boardW')) {
            // gia na sortaristoyn xronologika oi eisigiseis ton melon tis ektelestikis
            var tempArray = historySteps[step].judgment
            tempArray.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date)
            })
            for (let index = 0; index < 3; index++) {
              if (historySteps[step].judgment[index].comment !== null) {
                internalComments.push({status: historySteps[step].applicationStatus,
                  internalComment: historySteps[step].judgment[index].comment,
                  dateCompleted: historySteps[step].judgment[index].date,
                  name: historySteps[step].judgment[index].firstname + ' ' + historySteps[step].judgment[index].surname,
                  role: historySteps[step].role})
              }
            }
          }
        }
      }
    }
  }
  return internalComments
}
function allProposals (workingApplication) {
  let allProposals = []
  if (workingApplication.applicationHistory) {
    let historySteps = workingApplication.applicationHistory.slice(0).reverse()
    for (let step = 0; step < historySteps.length; step++) {
      if (historySteps[step].judgment !== null) {
        if (historySteps[step].judgment.proposal !== undefined) {
          if (historySteps[step].judgment.proposal !== null && historySteps[step].judgment.proposal !== '' && historySteps[step].dateCompleted !== null) {
            allProposals.push({status: historySteps[step].applicationStatus,
              proposal: historySteps[step].judgment.proposal,
              dateCompleted: historySteps[step].dateCompleted,
              name: historySteps[step].user.name + ' ' + historySteps[step].user.surname,
              role: historySteps[step].role})
          }
        } else {
          if (historySteps[step].applicationStatus.includes('boardW')) {
            // gia na sortaristoyn xronologika ta sxolia ton melon tis ektelestikis
            var tempArray = historySteps[step].judgment
            tempArray.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date)
            })
            for (let index = 0; index < 3; index++) {
              if (historySteps[step].judgment[index].proposal !== null && historySteps[step].judgment[index].proposal !== undefined) {
                allProposals.push({status: historySteps[step].applicationStatus,
                  proposal: historySteps[step].judgment[index].proposal,
                  dateCompleted: historySteps[step].judgment[index].date,
                  name: historySteps[step].judgment[index].firstname + ' ' + historySteps[step].judgment[index].surname,
                  role: historySteps[step].role})
              }
            }
          }
        }
      }
    }
  }
  // if (allProposals.length === 0) {
  //   allProposals.push({status: 'no data',
  //   proposal: 'no data',
  //   dateCompleted: 'no data',
  //   name: 'no data',
  //   role: 'no data'})
  // }
  return allProposals
}

function moveLeaderFirst (board) {
  const leaderIndex = board.findIndex(member => member.isCoordinator === 1)
  if (leaderIndex <= 0) {
    return board
  }
  const result = [...board]
  const leader = result.splice(leaderIndex, 1)[0]
  result.unshift(leader)
  return result
}

function hasRelevantApp (app) {
  return ['reappraisal', 'compensatory'].includes(app.applicationType)
}

function getAcademicFieldName (app, stepJudgement) {
  try {
    if (hasRelevantApp(app)) {
      if (hasRelevantApp(app.relevantApplication)) {
        return app.relevantApplication.relevantAppl.academicField.name
      } else {
        return app.relevantAppl.academicField.name
      }
    } else {
      return stepJudgement.academicField.name
    }
  } catch (err) {
    console.log('Error retrieving academic field name', err)
    return '---'
  }
}

function history (workingApplication, presidentDecisions) {
  let calcHistoryLine = []
  if (workingApplication.applicationHistory) {
    // let presidentDecisionForPrint = workingApplication.applicationHistory.slice().reverse()
    //   .find(step => step.applicationStatus === 'presidentW_Viewer').judgment.decision
    let groupTemp = 0
    let titleHover = ''
    let contentTemp = ''
    let endTemp = ''
    let style = "<div style='word-wrap: normal; width: 400px; white-space: normal; z-index: 1200;'>"
    let historySteps = workingApplication.applicationHistory.slice(0)
    for (let step = 0; step < historySteps.length; step++) {
      // let rerouteComment = historySteps[step].reroute
      //   ? historySteps[step].rerouteComment
      //     ? historySteps[step].rerouteComment
      //     : historySteps[step].releaseComment
      //   : null
      // temporary fix until reroute variable fixed in backend
      let rerouteComment = historySteps[step].rerouteComment
        ? historySteps[step].rerouteComment
        : historySteps[step].releaseComment
      let dialog = null
      let returnBoardComment = historySteps[step].reappBoardCoordinatorComment
      if (historySteps[step].judgment && historySteps[step].judgment.externalChat && historySteps[step].judgment.externalChat.id) {
        dialog = historySteps[step].judgment.externalChat.messages.reduce((str, mes) => {
          return str + `<div>${mes.username}: ${mes.text}</div>`
        }, '')
      }

      switch (historySteps[step].applicationStatus) {
        case 'userW_':
          groupTemp = 0
          titleHover = '<div>Ο χρήστης ετοιμάζει την αίτηση του πριν</div> την υποβάλει οριστικά για επεξεργασία'
          contentTemp = 'Επεξεργασία από τον χρήστη'
          break
        case 'precheckersQueue':
          groupTemp = 1
          titleHover = `${style}
              Η αίτηση βρίσκεται στην ουρά προελέγχου όπου θα διαπιστωθεί
            </div>
            ${style}
              η πληρότητα των στοιχείων και των δικαιολογητικών
            </div>`
          contentTemp = 'Αναμονή για έλεγχο στοιχείων'
          break
        case 'precheckerW_':
          groupTemp = 2
          // ${historySteps[step].judgment.pendingReason == null ? 'Ολοκληρωμένη' : historySteps[step].judgment.pendingReason}</div>
          workingApplication.applicationType === 'reappraisal'
            ? titleHover = `${style}Υπάλληλος Προελέγχου: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
              ${style}Εισήγηση προς χρήστη: ${historySteps[step].judgment.pendingReason || '-'}</div>
              ${style}Ακαδημαϊκή περιοχή: ${workingApplication.relevantAppl.academicField.name || '-'}</div>
              ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
              ${style} ${dialog ? '<div>Διάλογος με πολίτη:</div>' + dialog : ''}`
            : titleHover = `${style}Υπάλληλος Προελέγχου: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
              ${style}Εισήγηση προς χρήστη: ${historySteps[step].judgment.pendingReason || '-'}</div>
              ${style}Ακαδημαϊκή περιοχή: ${historySteps[step].judgment.academicField.name || '-'}</div>
              ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
              ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
              ${style} ${dialog ? '<div>Διάλογος με πολίτη:</div>' + dialog : ''}`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'precheckerCompensatoryW_':
          groupTemp = 2
          titleHover = `${style}Αίτηση μετά από Εξετάσεις</div>
            ${style}Υπάλληλος Προελέγχου: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Εισήγηση προς χρήστη: ${historySteps[step].judgment.pendingReason || '-'}</div>
            ${style}Ακαδημαϊκή περιοχή: ${getAcademicFieldName(workingApplication, historySteps[step].judgment) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style} ${dialog ? '<div>Διάλογος με πολίτη:</div>' + dialog : ''}`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'deactivated':
          groupTemp = 2
          // titleHover = `${style}Υπάλληλος Προελέγχου: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
          titleHover = `${style}Υπάλληλος Προελέγχου: -</div>
            ${style}Σχόλιο απενεργοποίησης: ${historySteps[step].judgment.deactivateComment || '-'}</div>`
          // contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          contentTemp = '-'
          break
        case 'presidentW_Prechecker':
          groupTemp = 3
          workingApplication.applicationType === 'reappraisal'
            ? titleHover = `${style}Πρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
              ${style}Ακαδημαϊκή περιοχή: ${workingApplication.relevantAppl.academicField.name || '-'}</div>
              ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
              ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
              ${style}Εκπρόθεσμη: ${historySteps[step].judgment.overdue ? 'Ναι' : 'Όχι'}</div>`
            : titleHover = `${style}Πρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
              ${style}Ακαδημαϊκή Περιοχή: ${historySteps[step - 1].judgment.academicField.name || '-'}</div>
              ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
              ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
              ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
              ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>
              ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'proponentW_President':
          groupTemp = 4
          workingApplication.applicationType === 'reappraisal'
            ? titleHover = `${style}Εισήγηση: ${historySteps[step].judgment.proposal || '-'}</div>
              ${style}Χειριστής: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
              ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
              ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>`
            : titleHover = `${style}Εισήγηση: ${historySteps[step].judgment.proposal || '-'}</div>
              ${style}Χειριστής: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
              ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
              ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
              ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
              ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>
              ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
              ${style} ${dialog ? '<div>Διάλογος με πολίτη:</div>' + dialog : ''}`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'proponentW_Prechecker':
          groupTemp = 4
          workingApplication.applicationType === 'reappraisal'
            ? titleHover = `${style}Εισήγηση: ${historySteps[step].judgment.proposal || '-'}</div>
              ${style}Χειριστής: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
              ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
              ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>`
            : titleHover = `${style}Εισήγηση: ${historySteps[step].judgment.proposal || '-'}</div>
              ${style}Χειριστής: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
              ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
              ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
              ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
              ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>
              ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
              ${style} ${dialog ? '<div>Διάλογος με πολίτη:</div>' + dialog : ''}`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'proponentW_Admin':
          groupTemp = 4
          titleHover = `${style}Εισήγηση: ${historySteps[step].judgment.proposal || '-'}</div>
            ${style}Χειριστής: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>
            ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>`
          contentTemp = `<div style="color: red">${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'proponentW_ReappraisalBoard':
          groupTemp = 4
          titleHover = `${style}Προετοιμασία της αίτησης επανεξέτασης για την τελική απόφαση</div>
            ${style}Χειριστής: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: -</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'boardW_Proponent':
          groupTemp = 5
          titleHover = `${historySteps[step].boardName}
            ${style}Μελος: ${historySteps[step].judgment[0].firstname} ${historySteps[step].judgment[0].surname}
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[0].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[0].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[0].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[0].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[0].comment || '-'}</div>
            ${style}Μελος: ${historySteps[step].judgment[1].firstname} ${historySteps[step].judgment[1].surname}</div>
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[1].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[1].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[1].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[1].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[1].comment || '-'}</div>
            ${style}Μελος: ${historySteps[step].judgment[2].firstname} ${historySteps[step].judgment[2].surname}</div>
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[2].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[2].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[2].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[2].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[2].comment || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = historySteps[step].boardName
          break
        case 'boardW_President':
          groupTemp = 5
          titleHover = `${historySteps[step].boardName}
            ${style}Μελος: ${historySteps[step].judgment[0].firstname} ${historySteps[step].judgment[0].surname}
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[0].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[0].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[0].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[0].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[0].comment || '-'}</div>
            ${style}Μελος: ${historySteps[step].judgment[1].firstname} ${historySteps[step].judgment[1].surname}</div>
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[1].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[1].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[1].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[1].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[1].comment || '-'}</div>
            ${style}Μελος: ${historySteps[step].judgment[2].firstname} ${historySteps[step].judgment[2].surname}</div>
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[2].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[2].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[2].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[2].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[2].comment || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = historySteps[step].boardName
          break
        case 'proponentW_Board':
          groupTemp = 4
          titleHover = `${style}Εισήγηση: ${historySteps[step].judgment.proposal || '-'}</div>
            ${style}Χειριστής: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>
            ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'consultantW_Proponent':
          groupTemp = 6
          titleHover = `${style}Ακαδημαϊκός σύμβουλος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
          ${style}Εισήγηση: ${historySteps[step].judgment.proposal}</div>
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = 'Επεξεργασία από τον Ακαδημαικό Σύμβουλο'
          break
        case 'consultantW_President':
          groupTemp = 6
          titleHover = `${style}Αξιολογητής: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
          ${style}Εισήγηση: ${historySteps[step].judgment.proposal}</div>
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = 'Επεξεργασία από Αξιολογητή'
          break
        case 'boardW_Consultant':
          groupTemp = 5
          titleHover = `${historySteps[step].boardName}
            ${style}Μελος: ${historySteps[step].judgment[0].firstname} ${historySteps[step].judgment[0].surname}
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[0].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[0].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[0].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Συμφωνία με Ακ. Σύμβουλο: ${historySteps[step].judgment[0].agreeWithAC === true ? 'Συμφωνεί' : historySteps[step].judgment[0].agreeWithAC === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[0].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[0].comment || '-'}</div>
            ${style}Μελος: ${historySteps[step].judgment[1].firstname} ${historySteps[step].judgment[1].surname}</div>
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[1].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[1].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[1].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Συμφωνία με Ακ. Σύμβουλο: ${historySteps[step].judgment[1].agreeWithAC === true ? 'Συμφωνεί' : historySteps[step].judgment[1].agreeWithAC === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[1].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[1].comment || '-'}</div>            
            ${style}Μελος: ${historySteps[step].judgment[2].firstname} ${historySteps[step].judgment[2].surname}</div>
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[2].finalize ? 'Ναι' : 'Όχι'}
            ${style}Συμφωνία με Εισηγητή: ${historySteps[step].judgment[2].agreeWithProponent === true ? 'Συμφωνεί' : historySteps[step].judgment[2].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Συμφωνία με Ακ. Σύμβουλο: ${historySteps[step].judgment[2].agreeWithAC === true ? 'Συμφωνεί' : historySteps[step].judgment[2].agreeWithAC === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Εισήγηση: ${historySteps[step].judgment[2].proposal || '-'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[2].comment || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = historySteps[step].boardName
          break
        case 'boardW_Vice':
          groupTemp = 5
          titleHover = `${historySteps[step].boardName}
              ${style}Μελος: ${historySteps[step].judgment[0].firstname} ${historySteps[step].judgment[0].surname}
              ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[0].finalize ? 'Ναι' : 'Όχι'}
              ${style}Συμφωνία: ${historySteps[step].judgment[0].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[0].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
              ${style}Εισήγηση: ${historySteps[step].judgment[0].proposal || '-'}</div>
              ${style}Σχόλιο: ${historySteps[step].judgment[0].comment || '-'}</div>
              ${style}Μελος: ${historySteps[step].judgment[1].firstname} ${historySteps[step].judgment[1].surname}</div>
              ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[1].finalize ? 'Ναι' : 'Όχι'}
              ${style}Συμφωνία: ${historySteps[step].judgment[1].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[1].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
              ${style}Εισήγηση: ${historySteps[step].judgment[1].proposal || '-'}</div>
              ${style}Σχόλιο: ${historySteps[step].judgment[1].comment || '-'}</div>
              ${style}Μελος: ${historySteps[step].judgment[2].firstname} ${historySteps[step].judgment[2].surname}</div>
              ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[2].finalize ? 'Ναι' : 'Όχι'}
              ${style}Συμφωνία: ${historySteps[step].judgment[2].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[2].agreeWithProponent === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
              ${style}Εισήγηση: ${historySteps[step].judgment[2].proposal || '-'}</div>
              ${style}Σχόλιο: ${historySteps[step].judgment[2].comment || '-'}</div>
              ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>`
          contentTemp = historySteps[step].boardName
          break
        case 'reappraisalBoardW_Vice':
          groupTemp = 11
          titleHover = `${historySteps[step].reappraisalBoardName}
            ${style}Μελος: ${historySteps[step].judgment[0].firstname} ${historySteps[step].judgment[0].surname}
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[0].finalize ? 'Ναι' : 'Όχι'}
            ${style}Αποδοχή εισήγησης: ${historySteps[step].judgment[0].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[0].fullyAgreeWithReappraisal === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[0].comment || '-'}</div>
            ${style}Μελος: ${historySteps[step].judgment[1].firstname} ${historySteps[step].judgment[1].surname}
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[1].finalize ? 'Ναι' : 'Όχι'}
            ${style}Αποδοχή εισήγησης: ${historySteps[step].judgment[1].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[0].fullyAgreeWithReappraisal === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[1].comment || '-'}</div>
            ${style}Μελος: ${historySteps[step].judgment[2].firstname} ${historySteps[step].judgment[2].surname}
            ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[2].finalize ? 'Ναι' : 'Όχι'}
            ${style}Αποδοχή εισήγησης: ${historySteps[step].judgment[2].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[0].fullyAgreeWithReappraisal === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
            ${style}Σχόλιο: ${historySteps[step].judgment[2].comment || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>`
          contentTemp = historySteps[step].reappraisalBoardName
          break
        case 'reappraisalBoardW_President':
          const members = moveLeaderFirst(historySteps[step].judgment.reappraisalBoard.members).map(m => ({
            name: `${m.surname} ${m.firstname}`,
            accept: m.fullyAgreeWithReappraisal === 1,
            coordinator: m.isCoordinator === 1
          }))
          groupTemp = 11
          // titleHover = `Επιτροπή Επανεξέτασης: ${historySteps[step].reappraisalBoardName}
          //   ${style}Συντονιστής: ${historySteps[step].judgment[0].firstname} ${historySteps[step].judgment[0].surname}
          //   ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[0].finalize ? 'Ναι' : 'Όχι'}
          //   ${style}Αποδοχή εισήγησης: ${historySteps[step].judgment[0].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[0].fullyAgreeWithReappraisal === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
          //   ${style}Σχόλιο: ${historySteps[step].judgment[0].comment || '-'}</div>
          //   ${style}Μέλος: ${historySteps[step].judgment[1].firstname} ${historySteps[step].judgment[1].surname}
          //   ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[1].finalize ? 'Ναι' : 'Όχι'}
          //   ${style}Αποδοχή εισήγησης: ${historySteps[step].judgment[1].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[0].fullyAgreeWithReappraisal === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
          //   ${style}Σχόλιο: ${historySteps[step].judgment[1].comment || '-'}</div>
          //   ${style}Μέλος: ${historySteps[step].judgment[2].firstname} ${historySteps[step].judgment[2].surname}
          //   ${style}Οριστικοποιημένη εισήγηση: ${historySteps[step].judgment[2].finalize ? 'Ναι' : 'Όχι'}
          //   ${style}Αποδοχή εισήγησης: ${historySteps[step].judgment[2].fullyAgreeWithReappraisal === true ? 'Συμφωνεί' : historySteps[step].judgment[0].fullyAgreeWithReappraisal === null ? 'Δεν έχει αποφανθεί' : 'Διαφωνεί'}</div>
          //   ${style}Σχόλιο: ${historySteps[step].judgment[2].comment || '-'}</div>
          //   ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>`
          // contentTemp = historySteps[step].reappraisalBoardName
          // titleHover = `Η αίτηση βρίσκεται στην Επιτροπή Επανεξέτασης
          //   ${style}Συντονιστής: ${members[0].name}</div>
          //   ${style}Αποδοχή εισήγησης: ${members[0].accept ? 'Ναι' : 'Σε αναμονή'}</div>
          //   ${style}Μέλος: ${members[1].name}</div>
          //   ${style}Αποδοχή εισήγησης: ${members[1].accept ? 'Ναι' : 'Σε αναμονή'}</div>
          //   ${style}Μέλος: ${members[2].name}</div>
          //   ${style}Αποδοχή εισήγησης: ${members[2].accept ? 'Ναι' : 'Σε αναμονή'}</div>
          //   ${style}Σχόλιο: -</div>
          //   ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>`
          titleHover = `Η αίτηση βρίσκεται στην Επιτροπή Επανεξέτασης
            ${style}Συντονιστής: ${members[0].name}</div>
            ${style}Μέλος: ${members[1].name}</div>
            ${style}Μέλος: ${members[2].name}</div>
            ${style}Σχόλιο: -</div>
            ${style}${returnBoardComment ? 'Σχόλιο Επιστροφής στον Πρόεδρο: ' + returnBoardComment : ''}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>`
          contentTemp = 'Επιτροπή Επανεξέτασης'
          break
        case 'viewerW_Board':
          groupTemp = 9
          titleHover = `${style}Διοικητικός Έλεγχος: ${historySteps[step].user.surname} ${historySteps[step].user.name}
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = 'Προεργασία για την αποστολή στον Πρόεδρο'
          break
        case 'presidentW_Viewer':
          groupTemp = 3
          titleHover = `${style}Πρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
            ${style}Απόφαση: ${(historySteps[step].judgment.decision && presidentDecisions.find(decision => decision.id === historySteps[step].judgment.decision).decision_text) || '-'}</div>
            ${style}Τμήμα ισοτιμίας: ${historySteps[step].judgment.departmentName || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'presidentW_AcademicDirector':
          groupTemp = 3
          titleHover = `${style}Πρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
            ${style}Απόφαση: ${(historySteps[step].judgment.decision && presidentDecisions.find(decision => decision.id === historySteps[step].judgment.decision).decision_text) || '-'}</div>
            ${style}Τμήμα ισοτιμίας: ${historySteps[step].judgment.departmentName || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'presidentW_Consultant':
          groupTemp = 3
          titleHover = `${style}Πρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
            ${style}Απόφαση: ${(historySteps[step].judgment.decision && presidentDecisions.find(decision => decision.id === historySteps[step].judgment.decision).decision_text) || '-'}</div>
            ${style}Τμήμα ισοτιμίας: ${historySteps[step].judgment.departmentName || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'presidentW_after2fortnights':
          groupTemp = 3
          titleHover = `${style}Πρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
            ${style}Απόφαση: ${(historySteps[step].judgment.decision && presidentDecisions.find(decision => decision.id === historySteps[step].judgment.decision).decision_text) || '-'}</div>
            ${style}Τμήμα ισοτιμίας: ${historySteps[step].judgment.departmentName || '-'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'presidentW_AcademicDirector_Reappraisal':
          groupTemp = 3
          // titleHover = `${style}Πρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
          //   ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
          //   ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          //   ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          //   ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
          //   ${style}Απόφαση: ${(historySteps[step].judgment.decision && presidentDecisions.find(decision => decision.id === historySteps[step].judgment.decision).decision_text) || '-'}</div>
          //   ${style}Τμήμα ισοτιμίας: ${historySteps[step].judgment.departmentName || '-'}</div>
          //   ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          titleHover = `${style}Πρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'presidentW_ReappraisalBoard':
          groupTemp = 3
          titleHover = `${style}Επιστροφή στον Πρόεδρο: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
            ${style}Ανάθεση σε: ${translate(historySteps[step].judgment.assignedTo.role) || '-'}</div>
            ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
            ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
            ${style}${historySteps[step].judgment.assignedTo.uid === null ? 'Σε επεξεργασία' : 'Ολοκληρωμένη'}</div>
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}`
          break
        case 'viceW_President':
          groupTemp = 7
          titleHover = `${style}Αντιπρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
          ${style}Εισήγηση Αντιπρόεδρου: ${historySteps[step].judgment.comment}</div>
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = 'Επεξεργασία από τον σχετικό Αντιπρόεδρο'
          break
        case 'viceW_Prechecker':
          groupTemp = 7
          titleHover = `${style}Αντιπρόεδρος: ${historySteps[step].user.surname} ${historySteps[step].user.name}</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>`
          contentTemp = 'Επεξεργασία από τον σχετικό Αντιπρόεδρο'
          break
        case 'viewerW_Vice':
          groupTemp = 9
          titleHover = `${style}Διοικητικός Έλεγχος: ${historySteps[step].user.surname} ${historySteps[step].user.name}
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}` // contentTemp = 'Προεργασία για την αποστολή στον Πρόεδρο'
          break
        case 'viewerW_Proponent':
          groupTemp = 9
          // todo: put the name of the only person to not show null?
          titleHover = `${style}Διοικητικός Έλεγχος: ${historySteps[step].user.surname} ${historySteps[step].user.name}
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}` // contentTemp = 'Προεργασία για την αποστολή στον Πρόεδρο'
          break
        case 'academicDirectorW_Proponent':
          groupTemp = 12
          // titleHover = `${style} Ο Δ/ντής Ακαδ. Αναγνώρισης ετοιμάζει την εισηγησή του</div> πριν την υποβάλει οριστικά στον πρόεδρο
          titleHover = `${style} Ο Δ/ντής Ακαδ. Αναγνώρισης ετοιμάζει το Πρακτικό του Δ.Σ.</div> πριν την οριστική υποβολή του στον Πρόεδρο
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = 'Επεξεργασία από τον Δ/ντή Ακαδ. Αναγνώρισης'
          break
        case 'academicDirectorW_President':
          groupTemp = 12
          titleHover = `Ο διευθυντής αναγνώρισης προτείνει αντισταθμιστικά μέτρα</div>
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = 'Επεξεργασία από τον διευθυντή αναγνώρισης'
          break
        case 'academicDirectorW_ReappraisalBoard':
          groupTemp = 12
          // titleHover = `Ο Διευθυντής Αναγνώρισης επεξεργάζεται την εισήγηση της Επιτροπής Επανεξέτασης</div>
          titleHover = `${style} Ο Δ/ντής Ακαδ. Αναγνώρισης ετοιμάζει το Πρακτικό του Δ.Σ.</div> πριν την οριστική υποβολή του στον Πρόεδρο
          ${style}Εσωτερικό Σχόλιο: -</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = 'Επεξεργασία από τον Διευθυντή Αναγνώρισης'
          break
        case 'printDecisionW_':
          groupTemp = 10
          titleHover = `${style}Καταχωρητής Απόφασης: ${historySteps[step].user.surname} ${historySteps[step].user.name}
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}` // contentTemp = 'Προεργασία για την αποστολή στον Πρόεδρο'
          break
        case 'printDecisionW_President':
          groupTemp = 10
          titleHover = 'Καθαρογράψιμο της απόφασης'
          contentTemp = 'Καθαρογράψιμο της απόφασης'
          break
        case 'presidentW_PrintDecision':
          groupTemp = 3
          titleHover = `${style}Υπογραφή και έκδοση απόφασης
          ${style}Εσωτερικό Σχόλιο: ${historySteps[step].judgment.internalComment || '-'}</div>
          ${style}Σχόλιο πολίτη: ${workingApplication.userComment || '-'}</div>
          ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = `${historySteps[step].user.surname} ${historySteps[step].user.name}` // contentTemp = 'Υπογραφή και έκδοση απόφασης'
          break
        case 'president_finalized':
          groupTemp = 3
          titleHover = `${style}Αρχείο: ${historySteps[step].judgment.old_name}</div>
            Μπορείτε να το βρείτε στο tab Επισυναπτόμενα
            ${style}${rerouteComment ? 'Σχόλιο Αναδρομολόγησης: ' + rerouteComment : ''}</div>`
          contentTemp = 'Ενημέρωση ενδιαφερόμενου'
          break
      }
      // if (step < historySteps.length - 1) {
      endTemp = historySteps[step].dateCompleted
      // } else {
      //   endTemp = Date.now()
      // }
      // let startDate = historySteps[step].date
      calcHistoryLine.push({
        id: historySteps[step].id,
        group: groupTemp,
        content: contentTemp,
        start: historySteps[step].date,
        end: endTemp,
        title: titleHover
      })
    }
    const allRecognitions = workingApplication.attachedDocuments
      .filter(doc => doc.type === 20) || null

    if (allRecognitions && allRecognitions.length > 0) {
      if (allRecognitions.at(-1).downloadedByUserAt) {
        calcHistoryLine.push({
          id: 'doc:' + allRecognitions.at(-1).id,
          group: 0,
          content: 'Λήψη απόφασης',
          start: allRecognitions.at(-1).downloadedByUserAt,
          title: 'Η απόφαση παραλήφθηκε από τον αιτούντα'
        })
      } else {
        console.log('App ID: ' + workingApplication.id + ', Δεν υπάρχει βεβαίωση παραλαβής της τελευταίας απόφασης.')
      }
    }
  }
  return calcHistoryLine
}

const addAssignedToStatuses = ['precheckerW_', 'precheckerCompensatoryW_']

function interceptApplication (app) {
  // const lastPrechecker = [...workApp.applicationHistory].reverse()
  //   .find(step => step.applicationStatus === 'precheckerW_')
  // if (lastPrechecker) {
  //   if (!lastPrechecker.judgment.assignedTo) {
  //     lastPrechecker.judgment.assignedTo = { role: null, uid: null }
  //   }
  // }
  const lastItem = app.applicationHistory.at(-1)
  if (lastItem && addAssignedToStatuses.includes(lastItem.applicationStatus)) {
    if (!lastItem.judgment.assignedTo) {
      lastItem.judgment.assignedTo = { role: null, uid: null }
    }
  }
  return app
}

export default new Vuex.Store({
  modules: {
    auth,
    chat,
    users,
    dictionaryForMenu
  },
  state: {
    startTimer: false,
    searchedForeigner: {},
    searchedForeignUsers: [],
    showSearchedForeignUser: false,
    searchForeignVisible: false,
    BASE_URL: config.BASE_URL,
    DEBUG: config.DEBUG,
    OVERDUE_MESSAGE: config.OVERDUE_MESSAGE,
    searchedApplication: {},
    loadingSearchedApplication: false,
    loadingPresidentDecisions: false,
    showSearchedApplication: false,
    loadingSearchedApplications: false,
    loadingStats: false,
    searchedApps: [],
    stats: [],
    searchVisible: false,
    searchUniVisible: false,
    consultantsListVisible: false,
    phdRegistrationVisible: false,
    statsVisible: false,
    countries: [],
    meetings: [],
    presidentDecisions: [],
    academicAreas: [],
    internalComments: [],
    proposals: [],
    activeLane: '',
    history: [],
    searchedAppHistory: [],
    assignedApplications: [],
    assignedProponentApplications: [],
    assignedBoardApplications: [],
    assignedViceApplications: [],
    assignedPrintApplications: [],
    usersToAssign: [],
    loadingAssignedApplications: false,
    loadingUsersToAssign: false,
    loadingWorkingApplication: false,
    pendingNotifications: [],
    workingApplication: {},
    proponentAttachments: [],
    boardAttachments: [],
    reappBoardAttachments: [],
    reappraisalOverviewAttachments: [],
    boardMinutesOnReappAttachments: [],
    examResultsAttachments: [],
    finalGradeAttachments: [],
    viceAttachments: [],
    precheckerAttachments: [],
    attachedSimilarAct: [],
    showWorkingApplication: false,
    gettingCountries: false
  },
  actions: {
    LOAD_ACADEMIC_AREAS: function ({ commit, dispatch }) {
      if (this.state.academicAreas.length < 1) {
        axios.get(
          `${this.state.BASE_URL}/academic_areas`
        ).then((response) => {
          commit(
            MutationTypes.SET_ACADEMIC_AREAS,
            {
              academicAreas: response.data.data
            })
        }, (err) => {
          dispatch('BACKEND_ERROR_NOTIFY', err)
        })
      }
    },
    LOAD_PRESIDENT_DECISIONS: function ({ commit, dispatch }) {
      if (this.state.presidentDecisions.length < 1) {
        this.state.loadingPresidentDecisions = true
        axios.get(
          `${this.state.BASE_URL}/final_decisions`
        ).then((response) => {
          commit(
            MutationTypes.SET_PRESIDENT_DECISIONS,
            {
              presidentDecisions: response.data.data
            })
          this.state.loadingPresidentDecisions = false
        }, (err) => {
          dispatch('BACKEND_ERROR_NOTIFY', err)
          this.state.presidentDecisions = false
        })
      }
    },
    LOAD_COUNTRIES: function ({ commit, dispatch }) {
      this.state.gettingCountries = true
      axios.get(`${config.BASE_URL}/countries`)
        .then((response) => {
          // this.countries = response.data.data
          commit(
            MutationTypes.SET_COUNTRIES,
            {
              countries: response.data.data
            })
          this.state.gettingCountries = false
        }).catch(err => {
          this.state.gettingCountries = false
          dispatch('BACKEND_ERROR_NOTIFY', err)
        })
    },
    LOAD_MEETINGS: function ({ commit }, meetings) {
      commit(
        MutationTypes.SET_MEETINGS,
        {
          meetings: meetings
        })
    },
    SET_FOREIGN_USER: function ({ commit, dispatch }, id) {
      this.state.loadingSearchedApplication = true
      this.state.showSearchedForeignUser = false
      // axios.get('/workingApplication/'+ id.appId).then((response) => {
      axios.get(
        `${this.state.BASE_URL}/extusers/${id}`
      ).then((response) => {
        commit(MutationTypes.SET_FOREIGN_USER, { searchedForeigner: response.data.data })
      }).catch(err => {
        dispatch('BACKEND_ERROR_NOTIFY', err)
        this.state.loadingSearchedApplication = false
      })
    },
    SHOW_HIDE_FOREIGN_USER_SEARCH: function ({ commit }) {
      commit(MutationTypes.SHOW_HIDE_FOREIGN_USER_SEARCH)
    },
    LOAD_SEARCHED_FOREIGN_USERS: function ({ commit, dispatch }, info) {
      this.state.loadingSearchedApplications = true
      axios.get(
        `${this.state.BASE_URL}/foreignusers?surname=${info.surname}`
      ).then((response) => {
        commit(MutationTypes.LOAD_SEARCHED_FOREIGN_USERS, { foundForeigners: response.data.data })
        this.state.loadingSearchedApplications = false
      }, (err) => {
        dispatch('BACKEND_ERROR_NOTIFY', err)
        this.state.loadingSearchedApplications = false
      })
    },
    LOAD_SEARCHED_APPLICATION: function ({ commit, dispatch }, id) {
      this.state.loadingSearchedApplication = true
      this.state.showSearchedApplication = false
      // axios.get('/workingApplication/'+ id.appId).then((response) => {
      axios.get(
        `${this.state.BASE_URL}/users/uid/applications/${id}`
      ).then((response) => {
        commit(MutationTypes.SET_SEARCHED_APPLICATION, { searchedApp: response.data.data })
      }).catch(err => {
        dispatch('BACKEND_ERROR_NOTIFY', err)
        this.state.loadingSearchedApplication = false
      })
    },
    LOAD_SEARCHED_APPS: function ({ commit, dispatch }, info) {
      this.state.loadingSearchedApplications = true
      axios.get(
        this.state.BASE_URL + '/users/applications?' +
        'afm=' + info.afm + '&surname=' + info.surname + '&firstname=' + info.firstname + '&protocol=' + info.protocol.replace(/%/g, '_') +
        '&act=' + info.act.replace(/%/g, '_') + '&type=' + info.type + '&distant=' + info.distant +
        '&overdue=' + info.overdue + '&compensatory=' + info.compensatory + '&decision=' + info.decision +
        '&actdate-from=' + info.actdate_from + '&actdate-to=' + info.actdate_to +
        '&submit-from=' + info.submit_from + '&submit-to=' + info.submit_to + '&app-id=' + info.app_id +
        '&status=' + info.status + '&role=' + info.role + '&birthdate=' + info.birthDate +
        '&country=' + info.country + '&university=' + info.university +
        '&college=' + info.college + '&faculty=' + info.faculty +
        '&department=' + info.department + '&page=' + info.page + '&per_page=' + info.per_page
      ).then((response) => {
        commit(MutationTypes.LOAD_SEARCHED_APPS, { foundApps: response.data.data })
        this.state.loadingSearchedApplications = false
      }, (err) => {
        dispatch('BACKEND_ERROR_NOTIFY', err)
        this.state.loadingSearchedApplications = false
      })
    },
    LOAD_STATS: function ({ commit, dispatch }, info) {
      this.state.loadingStats = true
      axios.get(
        this.state.BASE_URL + '/users/applications?' +
        '&type=' + info.stats_type +
        '&submit-from=' + info.stats_submit_from + '&submit-to=' + info.stats_submit_to
      ).then((response) => {
        commit(MutationTypes.LOAD_STATS, { foundStats: response.data.data })
        this.state.loadingStats = false
      }, (err) => {
        dispatch('BACKEND_ERROR_NOTIFY', err)
        this.state.loadingStats = false
      })
    },
    SHOW_HIDE_APPSEARCH: function ({ commit }) {
      if (this.state.countries.length === 0) {
        axios.get(
          `${this.state.BASE_URL}/countries`
        ).then((response) => {
          commit(
            MutationTypes.SET_COUNTRIES,
            {
              countries: response.data.data
            })
        })
      }
      commit(MutationTypes.SHOW_HIDE_APPSEARCH)
    },
    SHOW_HIDE_UNISEARCH: function ({ commit }) {
      if (this.state.countries.length === 0) {
        axios.get(
          `${this.state.BASE_URL}/countries`
        ).then((response) => {
          commit(
            MutationTypes.SET_COUNTRIES,
            { countries: response.data.data }
          )
        })
      }
      commit(MutationTypes.SHOW_HIDE_UNISEARCH)
    },
    SHOW_HIDE_CONSULTANTS_LIST: function ({ commit }) {
      commit(MutationTypes.SHOW_HIDE_CONSULTANTS_LIST)
    },
    SHOW_HIDE_PHD_REGISTRATION: function ({ commit }) {
      commit(MutationTypes.SHOW_HIDE_PHD_REGISTRATION)
    },
    SHOW_HIDE_STATS: function ({ commit }) {
      commit(MutationTypes.SHOW_HIDE_STATS)
    },
    LOAD_ASSIGNED_APPLICATIONS: function ({ commit, dispatch }, laneFrom) {
      this.state.loadingAssignedApplications = true
      let p = axios.get(`${this.state.BASE_URL}/${this.state.auth.activeRole.toLowerCase()}s/uid/applications/${laneFrom}`)
        .then((response) => {
          commit(
            MutationTypes.SET_ASSIGNED_APPLICATIONS,
            {
              assignedApplications: response.data.data,
              activeLane: laneFrom
              // pendingNotifications: response.data.workingApplication.user.pendingNotifications
            }
          )
          return response.data.data
        }, (err) => {
          commit(MutationTypes.SET_ASSIGNED_APPLICATIONS, {
            assignedApplications: []
          })
          dispatch('BACKEND_ERROR_NOTIFY', err)
        })
      if (this.state.countries.length === 0) {
        axios.get(
          `${this.state.BASE_URL}/countries`
        ).then((response) => {
          commit(
            MutationTypes.SET_COUNTRIES,
            { countries: response.data.data }
          )
        })
      }
      return p
    },
    LOAD_USERS_TO_ASSIGN: function ({ commit, dispatch }) {
      this.state.loadingUsersToAssign = true
      // axios.get('/assignedApplications').then((response) => {
      // todo: key managment is crucial
      axios.get(
        'https://gateway.interoperability.gr/e-doatap/2.00/500'
      ).then((response) => {
        commit(
          MutationTypes.SET_USERS_TO_ASSIGN,
          {
            usersToAssign: response.data.usersToAssign
          }
        )
      }, (err) => {
        dispatch('BACKEND_ERROR_NOTIFY', err)
      })
    },
    LOAD_WORKING_APPLICATION: function ({ commit, dispatch }, id) {
      this.state.loadingWorkingApplication = true
      this.state.showWorkingApplication = false
      // axios.get('/workingApplication/'+ id.appId).then((response) => {
      axios.get(
        `${this.state.BASE_URL}/users/uid/applications/${id}`).then((response) => {
        commit(MutationTypes.SET_WORKING_APPLICATION, { workApp: interceptApplication(response.data.data) })
      }).catch(err => {
        dispatch('BACKEND_ERROR_NOTIFY', err)
        this.state.loadingWorkingApplication = false
      })
    },
    BACKEND_ERROR_NOTIFY: function ({ commit, dispatch }, err) {
      let tempMessage = ''
      try {
        console.log('BACKEND_ERROR_NOTIFY param', err)
        Object.keys(err.response.data.message).forEach(key => {
          tempMessage += err.response.data.message[key].reduce((acc, cur) =>
            acc.slice(0, -1) + ', ' + cur.slice(0, -1))
        })
        Notification.error({
          title: 'Λάθος',
          message: 'Δοκιμάστε ξανά! ' + tempMessage,
          duration: 0
        })
      } catch (error) {
        console.log('Error in BACKEND_ERROR_NOTIFY', error)
      }
    },
    RELEASE_WORKING_APPLICATION: function ({ commit, dispatch }, data) {
      let url = ''
      let body = {}
      if (data.releaseOrReroute === 'release') {
        url = `applications/${data.id}/release`
        body = {
          releaseData: { releaseByUser: data.role, releaseComment: data.comment }
        }
      } else if (data.releaseOrReroute === 'reroute') {
        url = `users/userId/applications/${data.id}/reroute`
        body = {
          releaseData: { releaseByUser: data.role, rerouteComment: data.comment }
        }
      } else if (data.releaseOrReroute === 'rerouteToPrintDecisionQueue') {
        url = `users/userId/applications/${data.id}/reroute_to_print_decision_queue`
        body = {
          releaseData: { releaseByUser: data.role, rerouteComment: data.comment }
        }
      }
      return axios.post(
        `${this.state.BASE_URL}/${url}`, body).then((response) => {
        if (this.state.activeLane !== '') {
          dispatch('LOAD_ASSIGNED_APPLICATIONS', this.state.activeLane)
        }
        Notification.success({
          title: 'Ειδοποίηση',
          message: 'Η αίτηση αποδεσμεύτηκε με επιτυχία',
          offset: 100
        })
        return response
      }).catch((err) => {
        dispatch('BACKEND_ERROR_NOTIFY', err)
        Notification.error({
          title: 'Ειδοποίηση',
          message: 'Η αίτηση δεν αποδεσμεύτηκε!',
          offset: 300
        })
        return err
      })
    },
    SET_WORKING_APPLICATION_ATTACHMENTS: function ({commit}, attachments) {
      commit(MutationTypes.SET_WORKING_APPLICATION_ATTACHMENTS, { attachments: attachments })
    },
    SET_BOARD_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_BOARD_ATTACHMENTS, { attachments: attachments })
    },
    SET_REAPPBOARD_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_REAPPBOARD_ATTACHMENTS, { attachments: attachments })
    },
    SET_REAPPRAISAL_OVERVIEW_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_REAPPRAISAL_OVERVIEW_ATTACHMENTS, { attachments: attachments })
    },
    SET_BOARD_MINUTES_ON_REAPP_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_BOARD_MINUTES_ON_REAPP_ATTACHMENTS, { attachments: attachments })
    },
    SET_EXAM_RESULTS_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_EXAM_RESULTS_ATTACHMENTS, { attachments: attachments })
    },
    SET_FINAL_GRADE_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_FINAL_GRADE_ATTACHMENTS, { attachments: attachments })
    },
    SET_PROPONENT_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_PROPONENT_ATTACHMENTS, { attachments: attachments })
    },
    SET_VICE_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_VICE_ATTACHMENTS, { attachments: attachments })
    },
    SET_PRECHECKER_ATTACHMENTS: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_PRECHECKER_ATTACHMENTS, { attachments: attachments })
    },
    SET_SIMILAR_ACT_ATTACHED: function ({ commit }, attachments) {
      attachments = attachments.filter(a => {
        if (a.file) {
          a.id = a.file.id
          a.name = a.file.old_name
          a.old_name = a.file.old_name
          a.path = a.file.path
          a.type = a.file.type
          a.uploadedBy = a.file.uploadedBy
          delete a.file
        }
        return true
      })
      commit(MutationTypes.SET_SIMILAR_ACT_ATTACHED, { attachments: attachments })
    }
  },
  mutations: {
    SET_FOREIGN_USER: (state, { searchedForeigner }) => { // not correct
      state.searchedForeigner = searchedForeigner
      state.showSearchedForeignUser = true
      state.loadingSearchedApplication = false
    },
    LOAD_SEARCHED_FOREIGN_USERS: (state, {foundForeigners}) => {
      state.searchedForeignUsers = foundForeigners
      state.showSearchedForeignUser = false
    },
    SHOW_HIDE_FOREIGN_USER_SEARCH: (state) => {
      state.searchForeignVisible = !state.searchForeignVisible
      state.searchedForeignUsers = []
      state.showSearchedForeignUser = false
    },
    SET_SEARCHED_APPLICATION: (state, { searchedApp }) => { // any click in another application will be view only
      state.searchedApplication = searchedApp
      state.showSearchedApplication = true
      state.loadingSearchedApplication = false
      state.searchedAppHistory = history(state.searchedApplication, state.presidentDecisions)
      state.internalComments = intComments(state.searchedApplication)
      state.proposals = allProposals(state.searchedApplication)
    },
    LOAD_SEARCHED_APPS: (state, {foundApps}) => {
      state.searchedApps = foundApps
      state.showSearchedApplication = false
    },
    LOAD_STATS: (state, {foundStats}) => {
      state.stats = foundStats
    },
    SHOW_HIDE_APPSEARCH: (state) => {
      state.searchVisible = !state.searchVisible
      state.searchedApps = []
      state.showSearchedApplication = false
    },
    SHOW_HIDE_UNISEARCH: (state) => {
      state.searchUniVisible = !state.searchUniVisible
    },
    SHOW_HIDE_CONSULTANTS_LIST: (state) => {
      state.consultantsListVisible = !state.consultantsListVisible
    },
    SHOW_HIDE_PHD_REGISTRATION: (state) => {
      state.phdRegistrationVisible = !state.phdRegistrationVisible
    },
    SET_ACADEMIC_AREAS: (state, academicAreas) => {
      state.academicAreas = academicAreas.academicAreas
    },
    SET_PRESIDENT_DECISIONS: (state, presidentDecisions) => {
      state.presidentDecisions = presidentDecisions.presidentDecisions
    },
    SHOW_HIDE_STATS: (state) => {
      state.statsVisible = !state.statsVisible
      state.stats = []
    },
    SET_COUNTRIES: (state, countries) => {
      state.countries = countries.countries
    },
    SET_MEETINGS: (state, meetings) => {
      state.meetings = meetings.meetings
    },
    // waiting to select new working application
    SET_ASSIGNED_APPLICATIONS: (state, { assignedApplications, activeLane }) => {
      state.assignedApplications = assignedApplications
      // state.pendingNotifications = pendingNotifications
      state.loadingAssignedApplications = false
      state.showWorkingApplication = false
      state.activeLane = activeLane
    },
    SET_USERS_TO_ASSIGN: (state, { usersToAssign }) => { // users to be assigned the working application
      state.usersToAssign = usersToAssign
      state.loadingUserstoAssign = false
    },
    SET_WORKING_APPLICATION: (state, { workApp }) => { // any click in another application will be view only
      state.workingApplication = workApp
      state.showWorkingApplication = true
      state.loadingWorkingApplication = false
      state.history = history(state.workingApplication, state.presidentDecisions)
      state.internalComments = intComments(state.workingApplication)
      state.proposals = allProposals(state.workingApplication)
      state.proponentAttachments = workApp.attachedDocuments.filter(doc => doc.type === 18)
      state.boardAttachments = workApp.attachedDocuments.filter(doc => doc.type === 25)
      state.reappBoardAttachments = workApp.attachedDocuments.filter(doc => doc.type === 1006 || doc.type === 1014)
      state.reappraisalOverviewAttachments = workApp.attachedDocuments.filter(doc => doc.type === 1016)
      state.boardMinutesOnReappAttachments = workApp.attachedDocuments.filter(doc => doc.type === 1015)
      state.examResultsAttachments = workApp.attachedDocuments.filter(doc => doc.type === 2007)
      state.finalGradeAttachments = workApp.attachedDocuments.filter(doc => doc.type === 2008)
      state.viceAttachments = workApp.attachedDocuments.filter(doc => doc.type === 26 || doc.type === 24)
      state.precheckerAttachments = workApp.attachedDocuments.filter(doc => doc.type === 21)
      state.attachedSimilarAct = workApp.attachedDocuments.filter(doc => doc.type === 19)
    },
    SET_WORKING_APPLICATION_ATTACHMENTS: (state, {attachments}) => {
      state.workingApplication.attachedDocuments = attachments
      state.proponentAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 18)
      state.precheckerAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 21)
      state.boardAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 25)
      state.reappBoardAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 1006 || doc.type === 1014)
      state.reappraisalOverviewAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 1016)
      state.boardMinutesOnReappAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 1015)
      state.examResultsAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 2007)
      state.finalGradeAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 2008)
      state.viceAttachments = state.workingApplication.attachedDocuments.filter(doc => doc.type === 26 || doc.type === 24)
    },
    SET_BOARD_ATTACHMENTS: (state, { attachments }) => {
      state.boardAttachments = attachments
      let boardDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 25)
      boardDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_REAPPBOARD_ATTACHMENTS: (state, { attachments }) => {
      state.reappBoardAttachments = attachments
      let reappBoardDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 1006 && doc.type !== 1014)
      reappBoardDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_REAPPRAISAL_OVERVIEW_ATTACHMENTS: (state, { attachments }) => {
      state.reappraisalOverviewAttachments = attachments
      let reappraisalOverviewDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 1016)
      reappraisalOverviewDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_BOARD_MINUTES_ON_REAPP_ATTACHMENTS: (state, { attachments }) => {
      state.boardMinutesOnReappAttachments = attachments
      let boardMinutesOnReappDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 1015)
      boardMinutesOnReappDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_EXAM_RESULTS_ATTACHMENTS: (state, { attachments }) => {
      state.examResultsAttachments = attachments
      let examResultsDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 2007)
      examResultsDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_FINAL_GRADE_ATTACHMENTS: (state, { attachments }) => {
      state.finalGradeAttachments = attachments
      let finalGradeDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 2008)
      finalGradeDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_VICE_ATTACHMENTS: (state, { attachments }) => {
      state.viceAttachments = attachments
      let viceDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 26 && doc.type !== 24)
      viceDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_PROPONENT_ATTACHMENTS: (state, { attachments }) => {
      state.proponentAttachments = attachments
      let propsDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 18)
      propsDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_PRECHECKER_ATTACHMENTS: (state, { attachments }) => {
      state.precheckerAttachments = attachments
      let propsDocs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 21)
      propsDocs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    },
    SET_SIMILAR_ACT_ATTACHED: (state, { attachments }) => {
      state.attachedSimilarAct = attachments
      let similarActs = attachments
      let oldDocs = state.workingApplication.attachedDocuments.filter(doc => doc.type !== 19)
      similarActs.forEach(doc => oldDocs.push(doc))
      state.workingApplication.attachedDocuments = oldDocs
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js